import { render, staticRenderFns } from "./SettlementsView.vue?vue&type=template&id=677e1b2d&scoped=true"
import script from "./SettlementsView.vue?vue&type=script&lang=js"
export * from "./SettlementsView.vue?vue&type=script&lang=js"
import style0 from "./SettlementsView.vue?vue&type=style&index=0&id=677e1b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e1b2d",
  null
  
)

export default component.exports